export const parsearDescripcionRaw = (data: any): any => {
    if (Array.isArray(data)) {
        return data.map(parsearDescripcionRaw);
    } else if (typeof data === 'object' && data !== null) {
        const newData: any = {};

        for (let key in data) {
            if (key === 'raw' && data[key]) {
                try {
                    newData["json"] = JSON.parse(data[key]) ;
                } catch (error) {
                    console.error('Error al parsear descripcion.raw:', error);
                    newData["json"] = data[key];
                }
            } else {
                newData[key] = parsearDescripcionRaw(data[key]);
            }
        }

        return newData;
    } else {
        return data;
    }
}
